<script setup lang="ts">
import Header from "@/components/organisms/common/Header.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { useRouter } from "vue-router";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import PointHistoryList from "@/components/organisms/mypage/PointHistoryList.vue";
import { accountService } from "@/app/services/AccountService";
import { ref, onBeforeMount } from "vue";
import { PointHistory } from "@/types/worker/PointHistory";

const QUERY_LIMIT = 100;
const { back } = useRouter();
const loader = useLoader();
const errorModal = useErrorModal();
const pointHistoryList = ref<PointHistory[]>([]);
const isFetching = ref<boolean>(false);
const isAllResultsFetched = ref<boolean>(false);

onBeforeMount(async () => {
  await fetchPointHistoryList();
});

const fetchPointHistoryList = async () => {
  if (isFetching.value || isAllResultsFetched.value) return;
  try {
    loader.show();
    isFetching.value = true;
    const query = {
      offset: pointHistoryList.value.length,
      limit: QUERY_LIMIT
    };
    const { results } = await accountService.fetchPointHistoryList(query);
    pointHistoryList.value = [...pointHistoryList.value, ...results];
    isAllResultsFetched.value = results.length < QUERY_LIMIT;
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    isFetching.value = false;
    loader.hide();
  }
};

const onClickBack = () => {
  back();
};
</script>

<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      ポイント履歴
    </Header>
    <PointHistoryList
      :pointHistoryList="pointHistoryList"
      @scrollToBottom="fetchPointHistoryList"
      class="my-3"
    />
  </div>
</template>
